import { ILogonDocument } from 'app/services/api5-service/api.interface';

import { DocHelper } from 'utils/dochelper';

import { SocialData } from '../model/social.interface';

/**
 * Get data for social component from login doc
 *
 * @param loginDoc - Doc for login page
 */
export function mapLoginDocToSocialData(
  loginDoc?: ILogonDocument,
): SocialData | null {
  if (!loginDoc || !loginDoc.imglinks) {
    return null;
  }

  const socialTitleMessage = DocHelper.getMessage('ntfb_login_with', loginDoc);
  const baseDir = `${loginDoc.$theme}${loginDoc.$localdir}`;
  const imageLinks = loginDoc.imglinks.elem.map(link => ({
    href: link.$href,
    name: link.$img,
  }));

  return {
    socialTitleMessage,
    baseDir,
    imageLinks,
  };
}
